import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={`header ${scrolled || isMenuOpen ? 'header-scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo">
          <img src="/logo.png" alt="천일 물류" className="logo-image" />
        </Link>

        <button
          className={`mobile-menu-toggle ${isMenuOpen ? 'menu-open' : ''}`}
          onClick={toggleMenu}
          aria-label="메뉴 토글"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <Link
            to="/"
            className={`nav-link ${isActive('/') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            홈
          </Link>
          <Link
            to="/service"
            className={`nav-link ${isActive('/service') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            서비스
          </Link>
          {/* <Link
            to="/solutions"
            className={`nav-link ${isActive('/solutions') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            솔루션
          </Link> */}
          <Link
            to="/facilities"
            className={`nav-link ${isActive('/facilities') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            시설
          </Link>
          <Link
            to="/contact"
            className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            견적
          </Link>
          <a
            href="https://www.chunilkor.co.kr"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
            onClick={() => setIsMenuOpen(false)}
          >
            회사소개
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;

